module.exports = __webpack_public_path__ + "media/images/emoticons/scorpius-f5497b83366d173e0e17c0ac17e50265.gif";